import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerFundraisers } from "../graphql/queries";
import { FundraiserProgress } from "../components/fundraiser/FundraiserProgress";
import { DonateButton } from "../components/fundraiser/DonateButton";

const client = generateClient();

export function Fundraisers(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      const pendingData = await client.graphql({
        query: listSlumSoccerFundraisers,
        variables: { limit: 100 },
      });

      const items = pendingData["data"]["listSlumSoccerFundraisers"].items;
      setData(items || []);
    } catch (error) {
      console.error("Error fetching fundraisers:", error);
    }
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
              Fundraisers
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Support our teams and players on their journey to represent India
              on the world stage.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            {data.map((fundraiser) => (
              <div
                key={fundraiser.fundraiserId}
                className="group relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.333rem)] bg-white rounded-xl shadow-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={fundraiser.image}
                    className="w-full h-full object-cover transform transition duration-500 group-hover:scale-110"
                    alt={fundraiser.title}
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-orange-600 mb-4">
                    {fundraiser.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {fundraiser.description}
                  </p>
                  <FundraiserProgress
                    goal={fundraiser.goalAmount}
                    raised={fundraiser.raisedAmount}
                    compact
                  />
                  <div className="flex justify-between items-center mt-6">
                    <Link
                      to={`/fundraiser/${fundraiser.fundraiserId}`}
                      className="inline-flex items-center text-orange-500 font-semibold group"
                    >
                      <span className="mr-2">View Details</span>
                      <svg
                        className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        ></path>
                      </svg>
                    </Link>
                    <DonateButton
                      label="Donate"
                      className="px-4 py-2 text-sm"
                      fundraiserId={fundraiser.fundraiserId}
                      fundraiserTitle={fundraiser.title}
                      paymentFor="TEAM"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {data.length === 0 && (
            <p className="text-center text-gray-500 mt-8">
              No fundraisers available right now.
            </p>
          )}
        </div>
      </section>
    </>
  );
}
